import { render, staticRenderFns } from "./StaticInfosList.vue?vue&type=template&id=3d8d1406"
import script from "./StaticInfosList.vue?vue&type=script&lang=js"
export * from "./StaticInfosList.vue?vue&type=script&lang=js"
import style0 from "./StaticInfosList.vue?vue&type=style&index=0&id=3d8d1406&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports